// @flow

export const getAction = (type: string, payload) => ({ type, payload })
